'use client';

import { useState } from 'react';
import FeedSidebar from './FeedSidebar';
import FeedCenter from './FeedCenter';
import FeedRightPanel from './FeedRightPanel';
import FeedTopbar from './FeedTopbar';

export default function FeedLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Topbar */}
      <FeedTopbar
        sidebarCollapsed={sidebarCollapsed}
        onToggleSidebar={() => setSidebarCollapsed((v) => !v)}
      />

      {/* Body */}
      <div className="flex flex-1 pt-14">
        {/* Left sidebar */}
        <FeedSidebar collapsed={sidebarCollapsed} />

        {/* Center feed */}
        <main
          className="flex-1 min-w-0 transition-all duration-300"
          style={{ marginLeft: sidebarCollapsed ? '64px' : '240px' }}
        >
          <div className="max-w-screen-2xl mx-auto px-4 lg:px-6 xl:px-8 py-6">
            <div className="flex gap-6 xl:gap-8">
              {/* Feed */}
              <div className="flex-1 min-w-0">
                <FeedCenter />
              </div>

              {/* Right panel */}
              <div className="hidden xl:block w-80 2xl:w-96 flex-shrink-0">
                <FeedRightPanel />
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}